<template>
  <div class="p-8 w-full min-h-screen">
    <Steps :step-count="stepCount" :page="currentForm" @setSteps="setSteps"/>
    <div class="mt-4 w-full min-h-screen">
      <el-alert
        v-if="formErrors.length > 0"
        class="mb-4"
        title="Form Errors"
        type="error"
        @close="close()"
        effect="dark">
        <ul>
          <li v-for="error in formErrors">{{error}}</li>
        </ul>
      </el-alert>
      <div class="w-full h-auto ">
        <transition
          name="fadeRight">
          <BasicDetailsForm v-if="this.stepCount === 0 && this.currentForm === 'basic'" @setSteps="setSteps" @reset="reset"/>
        </transition>
        <transition
          name="fadeRight">
          <CatalogForm v-if="this.stepCount === 1 && this.currentForm === 'catalog'" @setSteps="setSteps" @reset="reset" />
        </transition>
        <transition
          name="fadeRight">
          <AttributeForm v-if="this.stepCount === 2 && this.currentForm === 'attribute'" @setSteps="setSteps" @reset="reset" />
        </transition>
        <transition
          name="fadeRight">
          <Configuration v-if="this.stepCount === 3 && this.currentForm === 'config'" @submit="finish()" @setSteps="setSteps" @reset="reset" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Steps from './_includes/Create/Steps.vue';
import BasicDetailsForm from './_includes/Forms/BasicDetailsForm.vue';
import CatalogForm from './_includes/Forms/CatalogForm.vue';
import AttributeForm from './_includes/Forms/AttributeForm.vue';
import Configuration from './_includes/Forms/Configuration.vue';

export default {
  name: 'CreateProduct',
  data() {
    return {
      stepCount: 0,
      currentForm: 'basic',
    };
  },
  computed: {
    formErrors() {
      return this.$store.state.GlobalError.errors;
    },
  },
  components: {
    Steps,
    BasicDetailsForm,
    CatalogForm,
    AttributeForm,
    Configuration,
  },
  methods: {
    setSteps(args) {
      this.stepCount = args.step;
      this.currentForm = args.page;
    },

    reset(key) {
      this.$store.commit('InventoryModule/Products/resetProductMultipleData', { action: 'create', parent: key });
    },

    close() {
      this.$store.commit('GlobalError/setErrors', []);
    },

    switchPage(e) {
      switch (e.form) {
        case 'basic':
          this.stepCount = 0;
          this.currentForm = 'basic';
          break;
        case 'catalog':
        case 'outlets':
          this.stepCount = 1;
          this.currentForm = 'catalog';
          break;
        case 'attribute':
          this.stepCount = 2;
          this.currentForm = 'attribute';
          break;
        case 'config':
        case 'available':
          this.stepCount = 3;
          this.currentForm = 'config';
          break;
        default:
          this.stepCount = 0;
          this.currentForm = 'basic';
          break;
      }
    },

    resetItemStoreModel() {
      const basic = {
        name: null,
        description: null,
        extra_description: null,
        cost: 0,
        price: 0,
        discount: 0,
        vat: 0,
        weight: 0,
        status: false,
        on_sale: false,
        require_shipping: false,
        homepage_feature: false,
        dimension: null,
      };

      const config = {
        daily_order_limit: null,
        minimum_order: null,
      };

      this.$store.commit('InventoryModule/Products/setActionProperty', { action: 'create', parent: 'basic', payload: basic });
      this.$store.commit('InventoryModule/Products/setActionProperty', { action: 'create', parent: 'catalog', payload: {} });
      this.$store.commit('InventoryModule/Products/setActionProperty', { action: 'create', parent: 'outlets', payload: {} });
      this.$store.commit('InventoryModule/Products/setActionProperty', { action: 'create', parent: 'attributes', payload: {} });
      this.$store.commit('InventoryModule/Products/setActionProperty', { action: 'create', parent: 'available', payload: {} });
      this.$store.commit('InventoryModule/Products/setActionProperty', { action: 'create', parent: 'config', payload: config });
    },

    resetLocalStorage() {
      let ls = localStorage.getItem(process.env.VUE_APP_LS_KEY);
      ls = JSON.parse(ls);
      if (ls.InventoryModule.Products.product) {
        delete ls.InventoryModule.Products.product;
      }
      localStorage.setItem(process.env.VUE_APP_LS_KEY, ls);
    },

    async finish() {
      this.$store.commit('GlobalError/setErrors', []);
      try {
        const response = await this.$store.dispatch('InventoryModule/Products/createItem');
        this.resetItemStoreModel();
        this.resetLocalStorage();
        await this.$router.push(`/ecommerce/inventory/products/${response.slug}/edit?id=${response.id}`);
        this.$notify.success({
          title: 'Success',
          message: 'Product successfully created',
        });
      } catch (e) {
        console.log(e);
        if (e && e.form) {
          this.$store.commit('GlobalError/setErrors', e.messages);
          this.switchPage(e);
        } else {
          this.$notify.error({
            title: 'Error',
            message: e.message,
          });
        }
      }
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
};
</script>

<style scoped lang="scss">
@import "node_modules/vue2-animate/src/sass/vue2-animate.scss";
</style>
